import keyboardMatch from 'Utils/keymatch';
import UIWatch from 'Utils/ui-watcher';

const mqsl = [];
const escapeStackMutations = ['ui/toggleOverlay'];

function featureDetect(store, update) {
  let storage = true;

  try {
    const mod = new Date();
    let result;

    localStorage.setItem(mod, mod.toString());
    result = localStorage.getItem(mod) === mod.toString();
    localStorage.removeItem(mod);

    storage = result;
  } catch (e) {
    storage = false;
  }

  update('features', {
    iOS: !!navigator.platform.match(/iPhone|iPod|iPad/),
    storage,
  });
}

function inputType(store, update) {
  function type(eventInputType) {
    if (store.state.ui.inputType !== eventInputType) {
      update('inputType', eventInputType);
    }
  }

  function detectInputType(event) {
    type(event.pointerType);
  }

  function detectInputTypeFallback(event) {
    type(event.type === 'mousemove' ? 'mouse' : 'touch');
  }

  function handleKeys(event) {
    type('keyboard');

    if (keyboardMatch(event, 'Escape')) {
      store.dispatch('ui/escapeKey');
    }
  }

  if (window.PointerEvent) {
    window.addEventListener('pointerdown', detectInputType);
    window.addEventListener('pointermove', detectInputType);
  } else {
    window.addEventListener('mousemove', detectInputTypeFallback);
    window.addEventListener('touchstart', detectInputTypeFallback, {
      passive: true,
    });
  }

  window.addEventListener('keydown', handleKeys);
}

function mqs(breakpoints) {
  let currentMq = 'root';

  if (typeof window === 'undefined') {
    return currentMq;
  }

  breakpoints.entries.forEach(([key, breakpoint]) => {
    // only register form factor breakpoints
    if (key.substr(0, 3) !== 'mq-') {
      return;
    }

    const mql = window.matchMedia(breakpoint);

    mql.key = key.replace('mq-', '');

    if (mql.matches) {
      currentMq = key.replace('mq-', '');
    }

    mqsl.unshift(mql);
  });

  return currentMq;
}

function registerRAF(store, update) {
  function watchCallback(type, key, data) {
    update(key, data);
  }

  const watcher = UIWatch(watchCallback);

  watcher.start();
}

function watchBreakpoints(store, update) {
  mqsl.forEach((mq) =>
    mq.addListener((e) => {
      if (e.matches) {
        update('breakpoint', e.key || e.currentTarget.key);
      } else {
        const matchingMql = mqsl.find((mql) => mql.matches);
        const key = matchingMql ? matchingMql.key : 'root';

        update('breakpoint', key);
      }
    })
  );
}

function plugin(store) {
  if (typeof window === 'undefined') {
    return;
  }

  const currentMq = mqsl.find((mq) => mq.matches) || 'root';

  if (currentMq) {
    update('breakpoint', currentMq.key);
  }

  update('ssr', false);

  featureDetect(store, update);
  inputType(store, update);
  registerRAF(store, update);
  watchBreakpoints(store, update);

  const state = store.state.ui;

  function update(key, data) {
    store.commit(`ui/${key}`, data);
  }

  document.documentElement.classList.add(`user-input-${state.inputType}`);

  window.addEventListener('load', () => {
    update('loaded', true);
    update('breakpoint', currentMq.key);
    update('height', window.innerHeight);
    update('width', window.innerWidth);
  });

  store.subscribe(({ type, payload }, currentState) => {
    if (!escapeStackMutations.includes(type)) {
      return;
    }

    const mutation = type.replace('ui/', '');
    let opened = false;

    opened = currentState.ui.overlay.opened;

    if (payload !== undefined) {
      return;
    }

    store.commit('ui/escapeStack', { opened, mutation });
  });
}

export { mqs, plugin };
